// extracted by mini-css-extract-plugin
module.exports = {"team":"index_team_2DVTc","btn-create-team":"index_btn-create-team_1sPRO","btn-join-team":"index_btn-join-team_6aGOr"};